import React, { BaseSyntheticEvent, ReactNode } from "react";
import { useTranslation } from "react-i18next";
import useGetUrlLocale from "../../../../hooks/useGetUrlLocale";

type TModalImage = {
  src: string;
  width?: number;
  height?: number;
};

type TModalText = {
  innerText: string | ReactNode;
  className?: string;
};

interface CoreModalProps {
  show: boolean;
  onCancel?: () => void;
  onSkip?: () => void;
  title: string;
  text: TModalText;
  skipText?: string
  image: TModalImage;
}

export const CoreModal = ({
  show,
  onCancel,
  onSkip,
  title,
  text,
  skipText,
  image,
}: CoreModalProps) => {
  const { t } = useTranslation();
  const lng = useGetUrlLocale();

  const moveToPaymentPage = () => {
    window.location.href = `${process.env.REACT_APP_NEW_ADMIN}${lng}/payment`
    onCancel();
  };

  const closeByBackground = (e: BaseSyntheticEvent) => {
    e.stopPropagation();
    if (e.target.id === "confirmModal") onCancel();
  };

  if (window.self !== window.top) return <></>;

  return (
    <div
      id="confirmModal"
      className={`modal ${
        show ? "show d-flex" : ""
      } align-items-center justify-content-center`}
      style={{
        display: show ? "block" : "none",
        background: "rgb(0, 0, 0, 0.6)",
        zIndex: 1060
      }}
      onClick={(e) => closeByBackground(e)}
    >
      <div className="limitModal col-11" style={{ maxWidth: "500px", minWidth: "359px" }}>
        <div className="modal-content text-break d-flex flex-column align-items-center">
          <div className="col-12 modal-header border-0 pb-0 pb-md-3">
            <button
              className="btn-close"
              aria-label="Close"
              onClick={onCancel}
              style={{ height: "16px", width: "16px", opacity: "1" }}
            ></button>
          </div>
          <div className="border-0 text-center d-flex flex-column align-items-center px-3 pb-3">
            <img
              className="mb-3"
              src={image.src}
              width={image?.width || ""}
              height={image?.height || ""}
              alt="limit's image"
            />
            <h4 className="fw-bold fs-24-20 text-dark mb-2 text-capitalize text-nowrap">
              {title}
            </h4>
            <p className={`text-dark ${text?.className || ""} fs-16-14 m-0`}>
              {text.innerText}
            </p>
          </div>
          <div className="modal-footer border-0 col-12 pb-4 flex-column">
            <button
              type="button"
              className="btn btn-primary text-white fw-bold col-12 rounded-3 py-2 py-md-3 m-0 mb-3 mb-md-4"
              onClick={moveToPaymentPage}
            >
              {t("settings.Upgrade to Premium")}
            </button>
            <p
              onClick={onSkip ?? onCancel}
              className="d-inline text-decoration-underline text-dark fs-7 m-0 cursor-pointer"
            >
              {skipText ? skipText : t("settings.Keep Free Version")}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
